import NotReviewedCell from './component';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { reviewJourney } from 'redux/modules/journeys/effects';
import { getJourneyReviewStatus } from 'redux/modules/journeys/selectors';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['is_reviewed', 'isFinished', 'status'];

const forceReviewStatuses = ['IN_TRANSIT'];

const enhance = compose(
  withJourneyCardSelectors,
  connect(
    (state, props) => {
      const {
        is_reviewed: isReviewed,
        isFinished,
        status,
      } = props.selectors.getJourneyFields(state, props.journeyId, fields);

      const forceReview = isFinished || forceReviewStatuses.includes(status);
      return {
        isReviewed: forceReview ? true : isReviewed,
        reviewStatus: getJourneyReviewStatus(state, props.journeyId),
      };
    },
    {
      reviewJourney,
    }
  ),
  withHandlers({
    handleReviewJourney:
      ({ journeyId, is_reviewed, reviewJourney }) =>
      (e) => {
        if (is_reviewed) return;

        reviewJourney({ journeyId });
      },
  })
);

export default enhance(NotReviewedCell);
